import { siteInfo, heroStats } from '@/mocks/home';

export default function Hero() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/30"></div>

      <div className="section-container relative z-10 w-full py-16 md:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-accent-100 text-accent-700 mb-4 whitespace-nowrap">
              下拉式 · 翻页 · 弹窗 三种阅读模式
            </span>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-3">
              香蕉文化漫画网
              <br />
              <span className="text-primary-600">你的全能漫画阅读伙伴</span>
            </h1>

            <p className="text-sm md:text-base leading-relaxed text-foreground-600 mb-3 max-w-2xl lg:max-w-none">
              国内领先的漫画在线阅读平台，专注为漫画爱好者提供最优质的免费全集阅读体验。平台独创下拉式、翻页与弹窗三种阅读模式，收录超过15,000部韩漫、日漫和国漫精品资源，每日更新200+章节。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-6">
              {heroStats.map((s) => (
                <div key={s.label} className="text-center">
                  <p className="text-xl md:text-2xl font-heading font-bold text-accent-600">{s.value}</p>
                  <p className="text-xs text-foreground-500">{s.label}</p>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                onClick={(e) => { e.preventDefault(); handleScroll('#index'); }}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-compass-3-line text-lg w-4 h-4 flex items-center justify-center"></i>
                探索专题合集
              </a>
              <a
                href="#ranking"
                onClick={(e) => { e.preventDefault(); handleScroll('#ranking'); }}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-lg border border-foreground-300 text-foreground-700 font-medium text-sm hover:bg-background-100 hover:border-foreground-400 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line text-lg w-4 h-4 flex items-center justify-center"></i>
                查看人气排行
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[420px] md:max-w-[480px] aspect-[4/3] rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Vibrant%20colorful%20manga%20and%20webtoon%20collage%20illustration%2C%20multiple%20characters%20from%20different%20comic%20genres%2C%20Korean%20Japanese%20Chinese%20manga%20styles%20blended%2C%20dynamic%20action%20scenes%20and%20romantic%20moments%2C%20warm%20vibrant%20color%20palette%20with%20yellow%20accents%2C%20decorative%20comic%20panel%20frames%2C%20energetic%20composition&width=960&height=720&seq=hero-main-visual&orientation=landscape"
                alt="香蕉文化漫画网 - 韩漫日漫国漫精选合集主视觉"
                className="w-full h-full object-cover object-top rounded-xl"
                loading="eager"
              />
              <div className="absolute inset-0 rounded-xl bg-gradient-to-tr from-black/10 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}